import {MultiSelectClass} from "./MultiSelect";
import { withTranslation } from 'react-i18next';

export const ITEM_ALL_CONVERSIONS = {"name": "Todas las conversiones primarias", "id": -7};

class ActionsMultiSelectClass extends MultiSelectClass {
    _getInitialSelectedItemIds() {
        const selectedItems = super._getInitialSelectedItemIds();
        if (selectedItems.length === 0 && this.props.hasAllPrimaryConversionsOption)
            return [ITEM_ALL_CONVERSIONS.id.toString()]

        return selectedItems;
    }

    _removeSelectedItem(selectedItemIds, itemIdToRemove) {
        return selectedItemIds.filter((selectedItem) => {
            return selectedItem !== itemIdToRemove;
        });
    }

    showButtonsFilters() {
        // Si tiene la opción "Todas las conversiones primarias" entonces no muestra "Selecctar Totos" / "Desseleccionar todos"
        return this.props.hasAllPrimaryConversionsOption !== true;
    }

    handleChangeItem(event) {
        const isChecked = event.target.checked;
        let selectedItems = null;
        const itemId = event.target.dataset.id;
        if (isChecked) {
            if(itemId === ITEM_ALL_CONVERSIONS.id.toString())
                selectedItems = [ITEM_ALL_CONVERSIONS.id.toString()]
            else {
                selectedItems = this.state.selectedItemIds.concat([itemId]);
                selectedItems = this._removeSelectedItem(selectedItems, ITEM_ALL_CONVERSIONS.id.toString())
            }
        } else {
            if(itemId !== ITEM_ALL_CONVERSIONS.id.toString()){
                selectedItems = this._removeSelectedItem(this.state.selectedItemIds, itemId)
                if(selectedItems.length === 0)
                    selectedItems = [ITEM_ALL_CONVERSIONS.id.toString()]
            }
            else
                selectedItems = [ITEM_ALL_CONVERSIONS.id.toString()]
        }

        this._setSelectedItems(selectedItems);
    }

    _setSelectedItems(selectedItems) {
        this.setState({selectedItemIds: selectedItems}, () => {

            // Don't pass the "All conversions" item. That's internal to this component
            const actionsIds =  selectedItems.filter(item => item !== ITEM_ALL_CONVERSIONS.id.toString());
            this.props.onChange(actionsIds)

        });
    }

    _getAllPrimaryConversionsItem() {
        const { t } = this.props;
        return {
            "is_custom": false,
            "description": t('actions_multi_select.all_primary_conversions'),
            "action_id": ITEM_ALL_CONVERSIONS["id"],
            "name": t('actions_multi_select.all_primary_conversions'),
            "status": "ACTIVE",
            "type": null
        }
    }

    _getItems() {
        if(this.props.hasAllPrimaryConversionsOption === true)
            return [this._getAllPrimaryConversionsItem()].concat(this.props.items);
        return this.props.items;
    }
}

export const ActionsMultiSelect = withTranslation()(ActionsMultiSelectClass);
export default ActionsMultiSelect;